import React, { useState, useEffect } from "react";
import chatIcon from "../images/chat.png";
import reportIcon from "../images/reports.png";
import arrow from "../images/arrow.png";

import Button from "react-bootstrap/Button";
import "./Home.css";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Stack from "react-bootstrap/Stack";
import { ProfileView } from "../pages/ProfileView";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import axios from "axios";
import Moment from "react-moment";

export const Home = () => {
  function goToJams() {
    window.location.href = "/chat";
  }
  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );
  const [recentActivity, setRecentActivity] = useState();
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/get_partners",
        {
          sender_id: profile.email,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setPartners(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (profile.email) {
      axios
        .post(
          process.env.REACT_APP_API_DOMAIN + "/getUserActivities",
          {
            userId: profile.email,
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          let fixed_results = [];

          for (var r in response.data) {
            var rObj = response.data[r];
            var newObj = rObj;
            var isoTimestamp = rObj["timestamp"].replace(" ", "T");
            isoTimestamp += "Z";
            newObj.timestamp = isoTimestamp;
            fixed_results.push(newObj);
          }
          setRecentActivity(fixed_results);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [profile]);

  function onClickChat(message) {
    let partner_id = message.partner_id;
    let conversation_id = message.id;

    var i = 0;
    var s = 0;
    for (var p in partners) {
      var p_o = partners[p];
      console.log("p_o.partner_id ", p_o.partner_id);
      if (p_o.partner_id == partner_id) {
        s = i;
      }
      i += 1;
    }
    console.log(partner_id);
    window.location.href =
      "/chat?selected_index=" + s + "&conversation_id=" + conversation_id;
  }

  function onClickJam(message) {
    let partner_id = message.partner_id;
    let conversation_id = message.id;

    var i = 0;
    var s = 0;
    for (var p in partners) {
      var p_o = partners[p];
      console.log("p_o.partner_id ", p_o.partner_id);
      if (p_o.partner_id == partner_id) {
        s = i;
      }
      i += 1;
    }
    console.log(partner_id);
    window.location.href =
      "/jam?selected_index=" + s + "&reportId=" + conversation_id;
  }
  return (
    <div>
      <div className="homeContainer">
        <div className="homeTitle">Jamafi</div>
        <div className="profileContainer">
          {" "}
          <ProfileView />
        </div>
      </div>
      <hr />
      <div className="contentContainer">
        <div className="startHome">Get Started</div>
        <Col>
          <a href="/createReport" className="targetLink">
            <div className="homeEntryCard" style={{ cursor: "pointer" }}>
              <img src={reportIcon} alt="" />
              <Stack direction="vertical">
                <div className="entryTitle">Jams</div>
                <div className="entrySubTitle">
                  Generate reports based on your data
                </div>
              </Stack>
              <img src={arrow} alt="" />
            </div>
          </a>
        </Col>
        <Col>
          <a href="/chat" className="targetLink">
            <div className="homeEntryCard">
              <img src={chatIcon} alt="" />
              <Stack direction="vertical">
                <div className="entryTitle">Credit Copilot</div>
                <div className="entrySubTitle">
                  Ask questions about your data
                </div>
              </Stack>
              <img src={arrow} alt="" />
            </div>
          </a>
        </Col>
        {/* <Col>
          <a href="/userActivity" className="targetLink">
            <div className="homeEntryCard">
              <img src={chatIcon} alt="" />
              <Stack direction="vertical">
                <div className="entryTitle">User Activity</div>
                <div className="entrySubTitle">View all user activty</div>
              </Stack>
              <img src={arrow} alt="" />
            </div>
          </a>
        </Col> */}
        <div className="recentActivity">Recent Activity</div>
        <div class="table-container">
          {recentActivity && recentActivity.length > 0 ? (
            <table class="custom-table">
              <thead>
                <tr>
                  <th class="sticky-header">Title</th>
                  <th class="sticky-header">Type</th>
                  <th class="sticky-header">Last Viewed</th>
                </tr>
              </thead>
              <tbody>
                {recentActivity.map((message, i) => {
                  return (
                    <tr>
                      {message.content_size ? (
                        <td style={{ width: "10%" }}>
                          {" "}
                          <td className="custom_title_cell">
                            <Button
                              variant="link"
                              className="targetLink"
                              onClick={() => onClickJam(message)}
                            >
                              {message.title}
                            </Button>
                          </td>
                        </td>
                      ) : (
                        <td style={{ width: "10%" }}>
                          {" "}
                          <td className="custom_title_cell">
                            <Button
                              variant="link"
                              className="targetLink"
                              onClick={() => onClickChat(message)}
                            >
                              {message.title}
                            </Button>
                          </td>
                        </td>
                      )}
                      {message.content_size ? (
                        <td style={{ width: "10%" }}>Report</td>
                      ) : (
                        <td style={{ width: "10%" }}>Chat</td>
                      )}

                      <td style={{ width: "10%" }}>
                        <Moment fromNow>{message.timestamp}</Moment>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : recentActivity && recentActivity.length == 0 ? (
            <div className="noRecentActivity">No Recent Activity</div>
          ) : (
            <div></div>
          )}
        </div>{" "}
      </div>
    </div>
  );
};

export default Home;
